import { render, staticRenderFns } from "./personinfo.vue?vue&type=template&id=18a85050&scoped=true"
import script from "./personinfo.vue?vue&type=script&lang=js"
export * from "./personinfo.vue?vue&type=script&lang=js"
import style0 from "./personinfo.vue?vue&type=style&index=0&id=18a85050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a85050",
  null
  
)

export default component.exports